export default {
	state: {
		listaBancos: {}
	},
	getters: {
		"listaBancos": state => state.listaBancos
	},
	mutations: {
		setListaBancos(state, payload) {
			state.listaBancos = payload
		}
	},
	actions: {
		atualizarEstadoListaBancos({ commit }, payload) {
			commit('setListaBancos', payload)
		}
	}
};